import React, { forwardRef } from 'react';

import DatePickerIconButtonVariant from './components/DatePickerIconButtonVariant/DatePickerIconButtonVariant';
import DatePickerInputVariant from './components/DatePickerInputVariant/DatePickerInputVariant';

export const renderDatePickerVariant = forwardRef((inputProps: any, newRef) => {
  const { variant, ...args } = inputProps;
  switch (variant) {
    case 'iconButton': {
      return <DatePickerIconButtonVariant {...args} ref={newRef} />;
    }
    case 'input': {
      return <DatePickerInputVariant {...args} ref={newRef} />;
    }
    default: {
      return <DatePickerInputVariant {...args} ref={newRef} />;
    }
  }
});
